module.exports = __webpack_public_path__ + "static/media/agriminer-overview.7d5de4d7.gif";